export default "__VITE_ASSET__BkPEfbt9__"